/* specRoutes.ts */

/* Constants */
import { Paths } from "src/shared/constants/common/Paths";

/* Interfaces */
import { AgentAnalysis } from "src/shared/interfaces/api/AgentSpec";

/**
 * The insights route each analysis of a spec belongs to.
 *
 * Applying a spec navigates here and then lets the page's existing
 * fetch hook run — the chat panel never dispatches an analysis
 * thunk itself, which would duplicate the loading, error and
 * caching handling the pages already have.
 */
export const AGENT_ANALYSIS_PATHS: Record<
  AgentAnalysis,
  string
> = {
  [AgentAnalysis.DESCRIPTIVE_STATISTICS]: `${Paths.INSIGHTS}${Paths.DESCRIPTIVE_STATISTICS}`,
  [AgentAnalysis.SURVIVAL_ANALYSIS]: `${Paths.INSIGHTS}${Paths.SURVIVAL_ANALYSIS}`,
  [AgentAnalysis.TREATMENT_PATTERNS]: `${Paths.INSIGHTS}${Paths.TREATMENT_PATTERNS}`,
};

/**
 * The analysis currently on screen, or null when the user is not on
 * an insights page. Sent to the agent so a prompt that only changes
 * a filter does not also navigate somewhere else.
 */
export const analysisFromPath = (
  pathname: string
): AgentAnalysis | null => {
  const match = (
    Object.entries(AGENT_ANALYSIS_PATHS) as [
      AgentAnalysis,
      string
    ][]
    // Matched on a path boundary rather than a bare prefix, so a future
    // route that merely starts with one of these cannot be mistaken for
    // it and have specs applied against the wrong page.
  ).find(
    ([, path]) =>
      pathname === path || pathname.startsWith(`${path}/`)
  );

  return match ? match[0] : null;
};
